<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Filter 4Over Products </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="filter.search"
              outlined
              label="Search"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.inSystem"
              :items="yesno_items"
              outlined
              label="In System?"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.missingData"
              :items="yesno_items"
              outlined
              label="Missing Data?"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.categoryId"
              :items="categories"
              item-text="name"
              item-value="id"
              label="Category"
              outlined
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Done
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, uniqBy, sortBy } from 'lodash';
export default {
  name: 'PrintFourOverFilter',
  data() {
    return {
      valid: false,
      drawer: false,
      saving: false,
      filter: {},
      yesno_items: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ]
    };
  },

  computed: {
    categories() {
      return sortBy(
        uniqBy(
          this.list.flatMap((x) => x.categories),
          'id'
        ),
        'name'
      );
    },
    ...mapGetters({
      list: 'print/fourover_list'
    })
  },
  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.FILTER_4OVER_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.FILTER_4OVER_SHOW, () => {
      this.drawer = true;
      this.filter = Object.assign({}, cloneDeep(this.$store.getters['print/fourover_filter']));
    });
  },
  methods: {
    save() {
      this.saving = true;
      Promise.all([this.$store.dispatch('print/setFourOverFilter', cloneDeep(this.filter))])
        .then(() => {
          this.drawer = false;
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
